import { useLayer } from '@coursera-web/statsig';

import type { EnterpriseSearchBarConfig } from 'bundles/search-common/components/searchbar/searchBarWrapperTypes';
import {
  SEARCH_ENTERPRISE_AUTOCOMPLETE_COURSES_S12N_INDEX_ID,
  SEARCH_MAIN_INDEX_ID,
  SEARCH_SUGGESTIONS_INDEX_ID,
} from 'bundles/search-common/constants';
import {
  ENTERPRISE_AUTOCOMPLETE_NON_CLIP_FACETFILTER_VALUES,
  ENTERPRISE_ORG_SCOPED_AUTOCOMPLETE_FACETFILTER_VALUES,
  MAX_SUGGESTION_COUNT,
} from 'bundles/search-common/constants/autocomplete';
import 'bundles/search-common/constants/filter';
import type { SearchConfig } from 'bundles/search-common/providers/searchTypes';

export const useAutocompleteSearchConfigs = (enterpriseSearchBarConfig?: EnterpriseSearchBarConfig): SearchConfig[] => {
  const isPersonalizationEnabled = useLayer('search-autocomplete').get('enable_personalization', false);

  if (enterpriseSearchBarConfig) {
    // Org-scoped routes also exclude degree-type products; program-scoped routes only exclude SFC.
    const facetFilters = enterpriseSearchBarConfig.enterpriseOrgSlug
      ? ENTERPRISE_ORG_SCOPED_AUTOCOMPLETE_FACETFILTER_VALUES
      : ENTERPRISE_AUTOCOMPLETE_NON_CLIP_FACETFILTER_VALUES;

    return [
      {
        id: SEARCH_ENTERPRISE_AUTOCOMPLETE_COURSES_S12N_INDEX_ID,
        entityType: 'PRODUCTS',
        limit: 1,
        disableRecommender: true,
        disableFacetFilterHack: true,
        facetFilters,
        searchContext: {
          searchInPrograms: { programIds: enterpriseSearchBarConfig.programIds },
        },
      },
      {
        id: SEARCH_SUGGESTIONS_INDEX_ID,
        entityType: 'SUGGESTIONS',
        limit: MAX_SUGGESTION_COUNT,
        disableRecommender: true,
        searchContext: {
          searchInPrograms: { programIds: enterpriseSearchBarConfig.programIds },
        },
      },
    ];
  }

  return [
    {
      id: SEARCH_MAIN_INDEX_ID,
      entityType: 'PRODUCTS',
      limit: 1,
      disableRecommender: true,
      searchContext: {
        searchProductSuggestions: {
          _: true,
        },
      },
    },
    {
      id: SEARCH_SUGGESTIONS_INDEX_ID,
      entityType: 'SUGGESTIONS',
      limit: MAX_SUGGESTION_COUNT,
      ...(!isPersonalizationEnabled && { disableRecommender: true }),
    },
  ];
};

export default useAutocompleteSearchConfigs;
